import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@shared/hooks/use-toast';
import { useTranslation } from 'react-i18next';
import { CourierFileDetailApiAdapter } from '../adapters';
import { AddPaymentRequest } from '../models';

export const useAddPayment = (fileId: number) => {
  const { toast } = useToast();
  const { t } = useTranslation('codCourierFileDetail');
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (data: AddPaymentRequest) => {
      const httpClient = createHttpClient(apiClientWH);
      const adapter = new CourierFileDetailApiAdapter(httpClient);
      return adapter.addPayment(fileId, data);
    },
    onSuccess: () => {
      // Invalidar las queries relacionadas para refrescar los datos
      queryClient.invalidateQueries({ queryKey: ['courier-cod-file', fileId] });
      queryClient.invalidateQueries({ queryKey: ['courier-cod-file-payments', fileId] });

      toast({
        title: t('addPayment.success.title', 'Pago añadido exitosamente'),
        description: t('addPayment.success.description', 'El pago se ha añadido al archivo correctamente'),
        variant: 'default',
      });
    },
    onError: (error: any) => {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        t('addPayment.error.unexpected', 'Ocurrió un error inesperado');

      toast({
        title: t('addPayment.error.title', 'Error al añadir pago'),
        description: errorMessage,
        variant: 'destructive',
      });
    },
  });

  return {
    addPayment: mutation.mutate,
    addPaymentAsync: mutation.mutateAsync,
    isAdding: mutation.isPending,
  };
};
